import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../../singleton/axios";

interface UploadResponse {
  message: string;
  imported_count: number;
  total_rows: number;
  skipped_count: number;
}

interface UploadError {
  error: string;
  code: string;
  details?: string;
}

export const useUploadTradingCsv = () => {
  const queryClient = useQueryClient();

  return useMutation<UploadResponse, UploadError, File>({
    mutationFn: async (file: File) => {
      const formData = new FormData();
      formData.append("file", file);

      const response = await api.post<UploadResponse>(
        "/portfolio/trading212-upload",
        formData
      );
      return response.data;
    },
    onSuccess: () => {
      // Remove portfolio queries entirely to force fresh fetch on navigation
      // Using removeQueries instead of invalidateQueries because:
      // - invalidateQueries marks as stale but can still return cached data
      // - removeQueries clears the cache, ensuring fresh data on next mount
      queryClient.removeQueries({ queryKey: ['portfolio'] });
      queryClient.removeQueries({ queryKey: ['currentPortfolio'] });
      queryClient.removeQueries({ queryKey: ['portfolioPrices'] });

      // Invalidate dividend-related queries (secondary data, invalidation is sufficient)
      queryClient.invalidateQueries({ queryKey: ['dividendAnalysis'] });
      queryClient.invalidateQueries({ queryKey: ['dividendStats'] });
      queryClient.invalidateQueries({ queryKey: ['portfolioDividendStats'] });
      queryClient.invalidateQueries({ queryKey: ['dividendCalendar'] });
    },
  });
};